import type { AnalyticsFiltersGroup } from '../components/AnalyticsFilterSelect/AnalyticsFiltersSelect.types'
import { parseCommaSeparatedValues } from './parseCommaSeparatedValues'

export const mapUrlParamsToFilters = (
  filters: AnalyticsFiltersGroup[],
  chartEntityParams: string | null | undefined,
  tiersIdsParams: string | null | undefined,
  intervalsParams: string | null | undefined,
  devicesParams: string | null | undefined,
) => {
  return filters.map((section) => {
    const paramName = section.param
    let urlValues: string[] = []

    switch (paramName) {
      case 'chartEntity':
        urlValues = parseCommaSeparatedValues(chartEntityParams)
        break
      case 'tiersIds':
        urlValues = parseCommaSeparatedValues(tiersIdsParams)
        break
      case 'intervals':
        urlValues = parseCommaSeparatedValues(intervalsParams)
        break
      case 'devices':
        urlValues = parseCommaSeparatedValues(devicesParams)
        break
      default:
        break
    }

    return {
      ...section,
      items: section.items.map((item) => {
        if (Array.isArray(item.value)) {
          const allValuesPresent = item.value.every((value) => urlValues.includes(value))

          return {
            ...item,
            checked: allValuesPresent,
          }
        }

        return {
          ...item,
          checked: urlValues.includes(item.value),
        }
      }),
    }
  })
}
